var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/containers/quoted_status_container.tsx";
import React from 'react';
import { cancelQuoteCompose } from 'soapbox/actions/compose';
import QuotedStatus from 'soapbox/components/quoted-status';
import { useAppSelector, useAppDispatch } from 'soapbox/hooks';
import { makeGetStatus } from 'soapbox/selectors';
const getStatus = makeGetStatus();

/** QuotedStatus shown in post composer. */
const QuotedStatusContainer = () => {
  const dispatch = useAppDispatch();
  const status = useAppSelector(state => getStatus(state, {
    id: state.compose.quote
  }));
  const onCancel = () => {
    dispatch(cancelQuoteCompose());
  };
  if (!status) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(QuotedStatus, {
    status: status,
    onCancel: onCancel,
    compose: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }));
};
export default QuotedStatusContainer;